import React from 'react';
import { Link } from 'react-router-dom';

export default function Unauthorized() {
  return (
    <div style={{ minHeight:'100vh', display:'grid', placeItems:'center', background:'#f5f7fb', padding:20 }}>
      <div style={{ maxWidth:520, textAlign:'center', background:'#fff', borderRadius:24, padding:32, boxShadow:'0 18px 40px rgba(15,23,42,.08)' }}>
        <h1>Access Restricted</h1>
        <p style={{ color:'#667085' }}>Your account does not have permission to open this area of the admin panel.</p>
        <Link to='/admin' style={{ display:'inline-block', marginTop:16, textDecoration:'none', background:'#0f5ef7', color:'#fff', padding:'12px 18px', borderRadius:12, fontWeight:700 }}>Back to dashboard</Link>
      </div>
    </div>
  );
}
